import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const COLS = [
  {
    title: "Product",
    links: [
      { name: "Find Jobs", to: "/#jobs" },
      { name: "Career Profile", to: "/signup" },
      { name: "ATS Checker", to: "/#ats" },
      { name: "CV Customization", to: "/#customize" },
      { name: "Interview Copilot", to: "/#interview" },
    ],
  },
  {
    title: "Platform",
    links: [
      { name: "Pricing", to: "/pricing" },
      { name: "Compare", to: "/compare" },
      { name: "For Recruiters", to: "/#how" },
      { name: "Application Autofill", to: "/#autofill" },
      { name: "4-Language CV", to: "/#languages" },
    ],
  },
  {
    title: "Company",
    links: [
      { name: "About Us", to: "/about" },
      { name: "Founder Story", to: "/about" },
      { name: "Careers", to: "/#jobs" },
      { name: "Privacy", to: "#" },
      { name: "Terms", to: "#" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-border/60 bg-card/50">
      <div className="cv-container grid grid-cols-2 gap-8 py-16 md:grid-cols-5">
        <div className="col-span-2">
          <Logo />
          <p className="mt-4 max-w-xs text-sm text-muted-foreground">
            Career, Evolved. From CV to interview — one intelligent platform connecting global talent and opportunity.
          </p>
          <p className="mt-6 font-heading text-sm font-bold text-electric">CVOLVE PRO</p>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <p className="label-caps mb-4">{c.title}</p>
            <ul className="space-y-3">
              {c.links.map((l) => (
                <li key={l.name}>
                  {l.to.startsWith("/") ? (
                    <Link
                      to={l.to}
                      className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {l.name}
                    </Link>
                  ) : (
                    <span className="cursor-pointer text-sm text-muted-foreground transition-colors hover:text-foreground">
                      {l.name}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-border/60">
        <div className="cv-container flex flex-col items-center justify-between gap-3 py-6 sm:flex-row">
          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} CVOLVE PRO. All rights reserved.</p>
          <p className="text-xs text-muted-foreground">Feature availability varies by plan and region.</p>
        </div>
      </div>
    </footer>
  );
}
